import React from "react";
import ReactToPrint from "react-to-print";

class PrintableComponent extends React.PureComponent {
  render() {
    const { data, title, voucherNumber, receiptNumber } = this.props;
    const currentDate = new Date().toLocaleString();
    const identifier = voucherNumber
      ? `Voucher Number: ${voucherNumber}`
      : receiptNumber
      ? `Receipt Number: ${receiptNumber}`
      : "Reference: N/A";

    return (
      <div className="print:p-8 print:max-w-md print:mx-auto">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-bold print:text-3xl">{title}</h1>
          <p className="text-sm text-gray-600">{identifier}</p>
          <p className="text-sm text-gray-600">{currentDate}</p>
        </div>
        <div className="py-4 my-4 border-t border-b border-gray-300">
          {Object.entries(data).map(([key, value], i) => (
            <div key={i} className="flex justify-between py-2">
              <span className="font-semibold capitalize">
                {key.replace(/_/g, " ")}
              </span>
              <span>{value}</span>
            </div>
          ))}
        </div>
        <p className="mt-4 text-sm text-center text-gray-600">
          Thank you for your business!
        </p>
      </div>
    );
  }
}

const ViewTemplate = ({
  data,
  title = "Receipt",
  voucherNumber,
  receiptNumber,
}) => {
  const componentRef = React.useRef();

  return (
    <div className="max-w-3xl mx-auto my-8 overflow-hidden bg-white ">
      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <h1 className="text-2xl font-bold">{title}</h1>
          <ReactToPrint
            trigger={() => (
              <button className="px-4 py-2 text-white transition duration-300 bg-blue-600 rounded hover:bg-blue-700">
                Print Receipt
              </button>
            )}
            content={() => componentRef.current}
          />
        </div>
        <PrintableComponent
          data={data}
          title={title}
          voucherNumber={voucherNumber}
          receiptNumber={receiptNumber}
          ref={componentRef}
        />
      </div>
    </div>
  );
};

export default ViewTemplate;
